import { render, staticRenderFns } from "./DocumentCsvOutput.vue?vue&type=template&id=5a0af483&"
import script from "./DocumentCsvOutput.vue?vue&type=script&lang=ts&"
export * from "./DocumentCsvOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports